import { api } from './axios';

const validateId = (id, name = 'ID') => {
    if (!id && id !== 0) throw new Error(`${name} is required`);
};

/**
 * API для работы с уведомлениями
 */
export const notificationsApi = {
    /**
     * Получить список уведомлений текущего пользователя
     * @param {Object} params - Параметры пагинации (page, size, sortBy, direction)
     * @returns {Promise<Object>}
     */
    list: async (params = {}) => {
        try {
            const { data } = await api.get('/notifications', { params });
            return data;
        } catch (error) {
            console.error('[notificationsApi.list] Failed to fetch notifications:', error.message);
            throw error;
        }
    },

    /**
     * Получить количество непрочитанных уведомлений
     * @returns {Promise<number>}
     */
    getUnreadCount: async () => {
        try {
            const { data } = await api.get('/notifications/unread-count');
            return data;
        } catch (error) {
            console.error('[notificationsApi.getUnreadCount] Failed to fetch unread count:', error.message);
            throw error;
        }
    },

    /**
     * Отметить уведомление как прочитанное
     * @param {string|number} id - ID уведомления
     * @returns {Promise<Object>}
     */
    markAsRead: async (id) => {
        validateId(id, 'Notification ID');
        try {
            const { data } = await api.patch(`/notifications/${id}/read`);
            return data;
        } catch (error) {
            console.error(`[notificationsApi.markAsRead] Failed to mark notification ${id} as read:`, error.message);
            throw error;
        }
    },

    /**
     * Отметить все уведомления как прочитанные
     * @returns {Promise<Object>} { markedAsRead: number }
     */
    markAllAsRead: async () => {
        try {
            const { data } = await api.patch('/notifications/read-all');
            return data;
        } catch (error) {
            console.error('[notificationsApi.markAllAsRead] Failed to mark all as read:', error.message);
            throw error;
        }
    },

    /**
     * Удалить уведомление
     * @param {string|number} id - ID уведомления
     * @returns {Promise<Object>}
     */
    remove: async (id) => {
        validateId(id, 'Notification ID');
        try {
            const { data } = await api.delete(`/notifications/${id}`);
            return data;
        } catch (error) {
            console.error(`[notificationsApi.remove] Failed to delete notification ${id}:`, error.message);
            throw error;
        }
    },

    /**
     * Получить настройки уведомлений
     * @returns {Promise<Array>}
     */
    getPreferences: async () => {
        try {
            const { data } = await api.get('/notifications/preferences');
            return data;
        } catch (error) {
            console.error('[notificationsApi.getPreferences] Failed to fetch preferences:', error.message);
            throw error;
        }
    },

    /**
     * Обновить настройки уведомлений для канала
     * @param {Object} payload - { channel: IN_APP | EMAIL | PUSH, enabledTypes: string[] }
     * @returns {Promise<Object>}
     */
    updatePreferences: async (payload) => {
        if (!payload) throw new Error('Preferences payload is required');
        try {
            const { data } = await api.put('/notifications/preferences', payload);
            return data;
        } catch (error) {
            console.error('[notificationsApi.updatePreferences] Failed to update preferences:', error.message);
            throw error;
        }
    }
};
